import {styled} from "@mui/material/styles";
import {DataGrid} from "@mui/x-data-grid";
import {DatePicker} from "@mui/x-date-pickers";

export const MuiDatePicker = styled(DatePicker)(({ theme }) => ({

    color: theme.palette.text.main,

    '& .MuiTypography-root':{
        color: theme.palette.text.main,

    },

    '& .MuiDayCalendar-monthContainer button': {
        color: theme.palette.text.main, // 将按钮颜色改为红色

    }

}))